// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot = require("..");
var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Pin$XodProject = require("./Pin.bs.js");
var Maybe$XodFuncTools = require("xod-func-tools/src/Maybe.bs.js");
var PatchPath$XodProject = require("./PatchPath.bs.js");
var Attachment$XodProject = require("./Attachment.bs.js");

function assocNode(patch, node) {
  return $dot$dot.assocNode(node, patch);
}

function dissocNode(patch, nodeId) {
  return $dot$dot.dissocNode(nodeId, patch);
}

function getNodeById(patch, nodeId) {
  return Maybe$XodFuncTools.toOption($dot$dot.getNodeById(nodeId, patch));
}

function upsertNodes(patch, nodes) {
  return $dot$dot.upsertNodes(Belt_List.toArray(nodes), patch);
}

function listNodes(patch) {
  return Belt_List.fromArray($dot$dot.listNodes(patch));
}

function assocLink(patch, link) {
  return $dot$dot.assocLink(link, patch);
}

function upsertLinks(patch, links) {
  return $dot$dot.upsertLinks(Belt_List.toArray(links), patch);
}

function listLinks(patch) {
  return Belt_List.fromArray($dot$dot.listLinks(patch));
}

function listPins(patch) {
  return Belt_List.fromArray($dot$dot.listPins(patch));
}

function omitLinks(patch, links) {
  return $dot$dot.omitLinks(Belt_List.toArray(links), patch);
}

function getPinByKey(patch, pinKey) {
  return Maybe$XodFuncTools.toOption($dot$dot.getPinByKey(pinKey, patch));
}

function getVariadicPinByKey(patch, node, pinKey) {
  return Maybe$XodFuncTools.toOption($dot$dot.getVariadicPinByKey(node, pinKey, patch));
}

function listInputPins(patch) {
  return Belt_List.keep(Belt_List.fromArray($dot$dot.listPins(patch)), (function (pin) {
                return Pin$XodProject.getDirection(pin) === /* Input */0;
              }));
}

function listOutputPins(patch) {
  return Belt_List.keep(Belt_List.fromArray($dot$dot.listPins(patch)), (function (pin) {
                return Pin$XodProject.getDirection(pin) === /* Output */1;
              }));
}

function identity(a) {
  return a;
}

function findPinByLabel(patch, label, normalize, direction) {
  var pins = Belt_List.keep((
          normalize ? Pin$XodProject.normalizeLabels : identity
        )(Belt_List.fromArray($dot$dot.listPins(patch))), (function (pin) {
          return Pin$XodProject.getLabel(pin) === label;
        }));
  var pins$1;
  if (direction !== undefined) {
    var dir = direction;
    pins$1 = Belt_List.keep(pins, (function (pin) {
            return Pin$XodProject.getDirection(pin) === dir;
          }));
  } else {
    pins$1 = pins;
  }
  if (pins$1 && !pins$1[1]) {
    return Caml_option.some(pins$1[0]);
  }
  
}

function getAttachments(t) {
  return Belt_List.fromArray($dot$dot.getPatchAttachments(t));
}

function getTabtestContent(t) {
  return Belt_Option.map(Belt_List.head(Belt_List.keep(Belt_List.fromArray($dot$dot.getPatchAttachments(t)), Attachment$XodProject.isTabtest)), Attachment$XodProject.getContent);
}

function hasTabtest(t) {
  return Belt_List.some(Belt_List.fromArray($dot$dot.getPatchAttachments(t)), Attachment$XodProject.isTabtest);
}

function isTerminal(patch) {
  return PatchPath$XodProject.isTerminal($dot$dot.getPatchPath(patch));
}

function isJumper(patch) {
  return PatchPath$XodProject.isJumper($dot$dot.getPatchPath(patch));
}

function isBus(patch) {
  return PatchPath$XodProject.isBus($dot$dot.getPatchPath(patch));
}

function isFromBus(patch) {
  return PatchPath$XodProject.isFromBus($dot$dot.getPatchPath(patch));
}

function isToBus(patch) {
  return PatchPath$XodProject.isToBus($dot$dot.getPatchPath(patch));
}

function create(prim) {
  return $dot$dot.createPatch();
}

function getPath(prim) {
  return $dot$dot.getPatchPath(prim);
}

function isNotImplementedInXod(prim) {
  return $dot$dot.isPatchNotImplementedInXod(prim);
}

function isRecord(prim) {
  return $dot$dot.isRecordPatch(prim);
}

function isUnpackRecord(prim) {
  return $dot$dot.isUnpackRecordPatch(prim);
}

function isAbstract(prim) {
  return $dot$dot.isAbstractPatch(prim);
}

exports.create = create;
exports.getPath = getPath;
exports.assocNode = assocNode;
exports.dissocNode = dissocNode;
exports.listNodes = listNodes;
exports.upsertNodes = upsertNodes;
exports.getNodeById = getNodeById;
exports.assocLink = assocLink;
exports.upsertLinks = upsertLinks;
exports.listLinks = listLinks;
exports.omitLinks = omitLinks;
exports.listPins = listPins;
exports.getPinByKey = getPinByKey;
exports.getVariadicPinByKey = getVariadicPinByKey;
exports.listInputPins = listInputPins;
exports.listOutputPins = listOutputPins;
exports.findPinByLabel = findPinByLabel;
exports.getAttachments = getAttachments;
exports.getTabtestContent = getTabtestContent;
exports.hasTabtest = hasTabtest;
exports.isNotImplementedInXod = isNotImplementedInXod;
exports.isRecord = isRecord;
exports.isUnpackRecord = isUnpackRecord;
exports.isAbstract = isAbstract;
exports.isTerminal = isTerminal;
exports.isJumper = isJumper;
exports.isBus = isBus;
exports.isFromBus = isFromBus;
exports.isToBus = isToBus;
/* .. Not a pure module */



// WEBPACK FOOTER //
// ../src/Patch.bs.js